/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BillingAccountACHTokenCreateDTO = {
    properties: {
        nickName: {
            type: 'string',
            isNullable: true,
        },
        bankName: {
            type: 'string',
            isNullable: true,
        },
        achType: {
            type: 'ACHTypeEnum',
            isRequired: true,
        },
        achAccountHolderType: {
            type: 'ACHAccountHolderTypeEnum',
            isRequired: true,
        },
        achAccount: {
            type: 'string',
            isRequired: true,
            maxLength: 17,
        },
        achRouting: {
            type: 'string',
            isRequired: true,
            maxLength: 9,
            minLength: 9,
        },
        firstName: {
            type: 'string',
            isNullable: true,
            maxLength: 32,
        },
        lastName: {
            type: 'string',
            isNullable: true,
            maxLength: 32,
        },
        streetAddress: {
            type: 'string',
            isNullable: true,
            maxLength: 100,
        },
        city: {
            type: 'string',
            isNullable: true,
            maxLength: 100,
        },
        state: {
            type: 'string',
            isNullable: true,
            maxLength: 2,
        },
        zip: {
            type: 'string',
            isRequired: true,
            maxLength: 5,
        },
        isSaved: {
            type: 'boolean',
            isNullable: true,
        },
    },
};